module.exports = __webpack_public_path__ + "static/media/helpdesk_stand.37df1cd2.png";